__turbopack_context__.v({
  "blok-big-title": "dropdown-module__O-6JJG__blok-big-title",
  "blok-subtitle": "dropdown-module__O-6JJG__blok-subtitle",
  "blok-title": "dropdown-module__O-6JJG__blok-title",
  "container": "dropdown-module__O-6JJG__container",
});
